import type { MenuConfig } from '~typings/menu'

import permisosLogisticaPg, { RESOURCE_LOGISTICA_PG } from '@/auth/permissions/modules/logisticaPg'
import {
    ROUTE_LPG_ASIGNACION_PRODUCTO_ENTIDAD,
    ROUTE_LPG_CREAR_CHOFERES,
    ROUTE_LPG_GESTION_CHOFERES,
    ROUTE_LPG_GESTION_CUENTA_LOGISTICA,
    ROUTE_LPG_GESTION_VEHICULOS,
    ROUTE_LPG_RUTA_VIAJE,
    ROUTE_LPG_TIPO_LOGISTICA,
} from '@/router/routes/logistica-pg/nombres/mantenimiento'

const { mantenimiento } = permisosLogisticaPg

export default [
    {
        title: 'logistica_pg.subopciones.registro_choferes',
        action: mantenimiento.registroChoferes,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_LPG_CREAR_CHOFERES,
    },
    {
        title: 'logistica_pg.subopciones.gestion_choferes',
        action: mantenimiento.gestionChoferes,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_LPG_GESTION_CHOFERES,
    },
    {
        title: 'logistica_pg.subopciones.gestion_vehiculos',
        action: mantenimiento.gestionVehiculos,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_LPG_GESTION_VEHICULOS,
    },
    {
        title: 'logistica_pg.subopciones.ruta_viaje',
        action: mantenimiento.rutaViaje,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_LPG_RUTA_VIAJE,
    },
    {
        title: 'logistica_pg.subopciones.asignacion_producto_entidad',
        action: mantenimiento.asignacionProductoEntidad,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_LPG_ASIGNACION_PRODUCTO_ENTIDAD,
    },
    {
        title: 'logistica_pg.subopciones.gestion_cuenta_logistica',
        action: mantenimiento.gestionCuentaLogistica,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_LPG_GESTION_CUENTA_LOGISTICA,
    },
    {
        title: 'logistica_pg.subopciones.tipo_logistica',
        action: mantenimiento.tipoLogistica,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_LPG_TIPO_LOGISTICA,
    },
] as MenuConfig[]
